import { PagingDto } from '../common/paging.dto'

export class FindAppointmentDto extends PagingDto {
  public searchText: string
  public status: string
}
